import { defineConfig } from 'sanity'
import { deskTool } from 'sanity/desk'
import { visionTool } from '@sanity/vision'
import { schemaTypes } from './schemas'
import deskStructure from './deskStructure'
import CustomDocumentActions from './sanity-actions/documentActions'

export default defineConfig({
  name: 'default',
  title: 'bansahandassociates',

  projectId: 'pzk671wu',
  dataset: 'production',

  plugins: [
    deskTool({ structure: deskStructure }),
    visionTool()
  ],

  basePath: '/content',

  document: {
    actions: (prev, context) => {
      if (context.schemaType === 'home') {
        return CustomDocumentActions
      }
      return prev
    },
  },

  schema: {
    types: schemaTypes,
  },
})
